interface TranscriptItem {
    title: string;
    text: string;
    type?: string;
}

export interface TranscriptSamples {
    [key: string]: TranscriptItem;
}

const transcriptSamples: TranscriptSamples = {

    '0': {
        title: "Weekly Product Update",
        type: 'sample',
        text: "Dan: Definitely, John. The first feature we're introducing is our new AI-powered recommendation system. The system analyzes user behavior and preferences to suggest the most relevant products. The beta tests have shown significant increases in user engagement.\n" +
            "John: That sounds promising! It would be great to see how it performs post-deployment.\n" +
            "Emily: Absolutely. The feature is scheduled for release in the second week of the next month. Our team is working hard on the final checks and tests to ensure a smooth rollout.\n" +
            "John: That's excellent. Emily, has the marketing team been looped in? They should be prepared to handle queries and explain the new features to our users.\n" +
            "Emily: Yes, John, the marketing team is on board. They're creating guides and video tutorials to educate our users about the new features.\n" +
            "Dan: That's great to hear. The next update is regarding the UI overhaul we've been planning for a while. We have finalized the designs and the development team is starting to implement them. Our main aim is to make the interface more user-friendly and intuitive.\n" +
            "John: I've seen the mockups and they look very modern and clean. Good job, team! When can we expect this to roll out?\n" +
            "Emily: We are targeting a release in the last week of next month. However, we'll be gradually rolling out these changes to our user base, starting with 10% of our users, and monitoring the feedback closely.\n" +
            "Dan: Thank you, Emily. Besides these, we are also working on improving our mobile app's performance. We've received feedback from users about slow loading times, and we are addressing it as a high-priority issue.\n" +
            "John: I agree, performance is key, especially for our mobile users. They expect quick and seamless access to our platform.\n" +
            "Emily: Our engineering team is investigating the performance issues and working on optimization. We are confident of improving the loading times by at least 50%.\n" +
            "Dan: That's encouraging. One last thing, we're also planning to expand to new markets in Europe. Research and analytics are in progress to understand these markets better.\n" +
            "John: That's an ambitious plan. I'm certain we're up to the task.\n" +
            "Dan: Absolutely. I'm really excited about the times ahead. We'll meet again next week with more updates. Thank you, everyone, for your time and contributions.\n" +
            "John: Thank you, Dan. Looking forward to the exciting times ahead!"
    },
    '1': {
        title: "Inbound Sales Call",
        type: 'sample',
        text: "Sales Representative: Good day! This is Jennifer from ABC Digital Solutions. How may I assist you today?\n" +
            "Customer: Hi Jennifer. I was referred to your company by a colleague. We're looking to improve our software systems and someone suggested you might be able to help us.\n" +
            "Sales Representative: That's wonderful, we'd be happy to assist. Can you tell me a bit more about the specific challenges you're facing with your current software systems?\n" +
            "Customer: Sure, our main issue is that our systems are outdated and not fully integrated, which causes a lot of inefficiency. We have multiple systems doing similar tasks, which isn't cost-effective or productive.\n" +
            "Sales Representative: I see, it sounds like your current setup is costing you in terms of both time and resources. This is a common challenge we help businesses like yours to overcome. At ABC Digital, we provide both software consulting and development services, which are designed to streamline your systems and improve your efficiency.\n" +
            "Customer: That sounds interesting. Could you tell me more about your process and what sort of services you provide?\n" +
            "Sales Representative: Absolutely! We begin with a consultation phase, where we'll learn more about your business needs and the problems you're experiencing. We'll also conduct an in-depth analysis of your current software systems to identify any gaps or redundancies.\n" +
            "After this analysis, our software development team steps in. They'll design a customized software solution that suits your unique business requirements, eliminating redundancies and improving efficiency. The goal is to create an integrated system that fulfills your needs while being user-friendly and cost-effective.\n" +
            "Customer: That seems like a good approach. However, we've had negative experiences in the past with over-complicated software that ended up being more trouble than it was worth. How can we be sure this won't happen with your solution?\n" +
            "Sales Representative: That's a valid concern. At ABC Digital, we put a premium on designing software that is as intuitive as it is efficient. Our team will work closely with your staff during the design phase to ensure the solution is easy to use and understand.\n" +
            "Additionally, we provide comprehensive training and ongoing support after the software is implemented. Our goal is to ensure you are comfortable with the new system and that it delivers the promised benefits.\n" +
            "Customer: That sounds reassuring. What would be the next step if we want to proceed?\n" +
            "Sales Representative: The next step would be to arrange a meeting with our product and engineering team, along with your technical staff. This will allow us to gain a deeper understanding of your needs, and discuss in detail how we can address them. During this meeting, we'll also discuss the scope of the project, timelines, and cost estimates.\n" +
            "Customer: Okay, I think we can arrange for that. I'd like to discuss this with my team first, and then we can set a date for the meeting.\n" +
            "Sales Representative: That sounds like a plan. I'll follow up with you in a few days to see how things are going and to answer any questions that may come up in the meantime. We're looking forward to potentially working together to improve your software systems.\n" +
            "Customer: Thank you, Jennifer. I appreciate the information and the straightforward approach.\n" +
            "Sales Representative: It's my pleasure. We believe in building strong relationships with our clients and providing transparent, efficient solutions. I look forward to our next conversation. Have a great day!\n" +
            "Customer: You too, Jennifer. Goodbye!\n" +
            "Sales Representative: Goodbye, and take care!"
    },
    '2': {
        title: "Outbound Sales Call",
        type: 'sample',
        text: "Sales Representative: Hello, this is Mike from ABC Digital Solutions. Am I speaking with Mr. Smith?\n" +
            "Customer: Yes, this is him. How can I help you?\n" +
            "Sales Representative: Hi Mr. Smith. I hope you're doing well. I am reaching out today to discuss some potential ways our software services can benefit your business. We offer specialized software consulting and development that can streamline operations and increase productivity. May I share some information about our offerings?\n" +
            "Customer: I'm always open to ideas that can improve our business. Please go ahead.\n" +
            "Sales Representative: Excellent! At ABC Digital Solutions, we first perform a detailed analysis of your current software systems to understand your unique business needs. We then develop a customized, integrated software solution to address any inefficiencies, redundancies, and gaps.\n" +
            "Customer: Interesting, but we've had some bad experiences with customized solutions in the past. They were too complicated to use and maintain.\n" +
            "Sales Representative: That's a valid concern, Mr. Smith. At ABC Digital, our focus is not just on creating a powerful tool, but also ensuring it's user-friendly. Our solutions are designed to be intuitive and easy to navigate, and we provide extensive training as well as ongoing support to ensure smooth transitions and operations.\n" +
            "Customer: That sounds more like it. However, I'd need to understand more about the practical side of things, like timelines, cost, and how the transition phase is managed.\n" +
            "Sales Representative: Absolutely, those are important factors to consider. To provide detailed answers to these questions, we'd need to understand your specific needs and challenges better. How about we set up a meeting with our product and engineering team, along with your technical staff, to discuss these aspects in detail?\n" +
            "Customer: That could be arranged. But I'd like to discuss this internally before committing to anything.\n" +
            "Sales Representative: Of course, I completely understand. In the meantime, I can send you some case studies and information about our services, so you can share these with your team.\n" +
            "Customer: That would be useful, please do.\n" +
            "Sales Representative: Great! I'll send those over right away. I'll also check in with you next week to answer any questions you or your team may have. How does that sound?\n" +
            "Customer: That sounds fine. I'll await your email and we can take it from there.\n" +
            "Sales Representative: Perfect, I appreciate your time today, Mr. Smith. I'm looking forward to our potential collaboration. Have a great day!\n" +
            "Customer: You too, Mike. Goodbye!\n" +
            "Sales Representative: Goodbye, and take care!"
    },
    '3': {
        title: "Customer Support Call",
        type: 'sample',
        text: "Agent: Hello, this is Sarah from ABC Digital Customer Support. How may I assist you today?\n" +
            "Customer: Hi Sarah, this is John. I'm having trouble logging into my account. I've already tried resetting my password, but it's still not working.\n" +
            "Agent: I'm sorry to hear that you're having trouble, John. Let's get this sorted out. Just to confirm, are you getting an error message when you try to log in?\n" +
            "Customer: Yes, it's saying \"Invalid Login Details\".\n" +
            "Agent: Thanks for the information, John. Let's first verify some details. Can you please confirm the email address associated with your account?\n" +
            "Customer: Sure, it's john.doe@example.com.\n" +
            "Agent: Thank you, John. Please bear with me for a moment while I check your account details.\n" +
            "Agent: John, I can see that your account is active and the email address is correct. You mentioned that you've tried resetting your password. After resetting, did you receive an email to confirm the change?\n" +
            "Customer: Yes, I did. I used the new password provided in the email, but still, it's not working.\n" +
            "Agent: That's odd. Let me investigate this a bit further. It might take a few minutes, is that okay with you?\n" +
            "Customer: Sure, please take your time.\n" +
            "Agent: Thank you for your patience, John. I've checked your account activity and it appears that there have been multiple unsuccessful login attempts from different locations. This could be why our security system has temporarily locked your account.\n" +
            "Customer: Oh, that's strange. I've only been trying to login from my home.\n" +
            "Agent: It could be someone trying to gain unauthorized access, but don't worry, our system is designed to prevent this. Now, let's proceed with unlocking your account. I'll need to verify some security questions to confirm your identity.\n" +
            "Customer: Alright, go ahead.\n" +
            "Agent: Thanks for verifying that, John. I've now unlocked your account. I'm going to send a password reset link to your email. When you receive it, please follow the instructions to set a new password.\n" +
            "Customer: Okay, I've just received the link. Let me reset the password.\n" +
            "Customer: I've reset the password now, and it worked! I'm able to log into my account.\n" +
            "Agent: That's great news, John! I'm glad we could resolve this issue. Just to be safe, I suggest enabling two-factor authentication on your account for additional security.\n" +
            "Customer: I'll do that, Sarah. Thanks for your help.\n" +
            "Agent: You're welcome, John. I'm glad I could assist you. If you have any more issues, don't hesitate to contact us. Have a great day!\n" +
            "Customer: You too, Sarah. Goodbye!\n" +
            "Agent: Goodbye, John. Take care!"
    },
    '4': {
        title: "Support Email",
        type: 'sample',
        text: 'Subject: Trouble Logging into My Account\n' +
            '\n' +
            'From: john.doe@example.com\n' +
            'To: support@abcdigital.com\n' +
            '\n' +
            'Hello,\n' +
            '\n' +
            'I\'m having trouble logging into my ABC Digital account. I\'ve tried resetting my password, but it\'s still not working. Can you assist?\n' +
            '\n' +
            'Best,\n' +
            'John\n' +
            '\n' +
            'From: support@abcdigital.com\n' +
            'To: john.doe@example.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hello John,\n' +
            '\n' +
            'I\'m sorry to hear that you\'re having trouble logging into your account. Can you please confirm if you are getting any error message while trying to log in?\n' +
            '\n' +
            'Best,\n' +
            'Sarah,\n' +
            'ABC Digital Support\n' +
            '\n' +
            'From: john.doe@example.com\n' +
            'To: support@abcdigital.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hi Sarah,\n' +
            '\n' +
            'Yes, I am getting an error message saying "Invalid Login Details". I have tried resetting the password but the issue persists.\n' +
            '\n' +
            'Best,\n' +
            'John\n' +
            '\n' +
            'From: support@abcdigital.com\n' +
            'To: john.doe@example.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hello John,\n' +
            '\n' +
            'Thank you for providing the details. Please give us a moment while we investigate this issue. We\'ll get back to you shortly.\n' +
            '\n' +
            'Best,\n' +
            'Sarah,\n' +
            'ABC Digital Support\n' +
            '\n' +
            'From: support@abcdigital.com\n' +
            'To: john.doe@example.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hello John,\n' +
            '\n' +
            'Upon checking your account, it appears that our security system has temporarily locked your account due to multiple unsuccessful login attempts from different locations. To unlock your account, we need to verify some security questions.\n' +
            '\n' +
            'Question 1: [Security Question]\n' +
            'Question 2: [Security Question]\n' +
            '\n' +
            'Could you please reply with your answers?\n' +
            '\n' +
            'Best,\n' +
            'Sarah,\n' +
            'ABC Digital Support\n' +
            '\n' +
            'From: john.doe@example.com\n' +
            'To: support@abcdigital.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hi Sarah,\n' +
            '\n' +
            'Here are the answers to the security questions:\n' +
            '\n' +
            'Answer 1: [Answer]\n' +
            'Answer 2: [Answer]\n' +
            '\n' +
            'Best,\n' +
            'John\n' +
            '\n' +
            'From: support@abcdigital.com\n' +
            'To: john.doe@example.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hello John,\n' +
            '\n' +
            'Thank you for providing the answers. I\'ve now unlocked your account. I am sending you a password reset link to your email. Please follow the instructions to set a new password.\n' +
            '\n' +
            'Best,\n' +
            'Sarah,\n' +
            'ABC Digital Support\n' +
            '\n' +
            'From: john.doe@example.com\n' +
            'To: support@abcdigital.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hi Sarah,\n' +
            '\n' +
            'I\'ve reset my password and I\'m now able to log into my account. Thanks for your help!\n' +
            '\n' +
            'Best,\n' +
            'John\n' +
            '\n' +
            'From: support@abcdigital.com\n' +
            'To: john.doe@example.com\n' +
            '\n' +
            'Subject: Re: Trouble Logging into My Account\n' +
            '\n' +
            'Hello John,\n' +
            '\n' +
            'That\'s great news! I\'m glad we could resolve this issue. Just to be safe, I suggest enabling two-factor authentication on your account for additional security. If you have any more issues, don\'t hesitate to contact us. Have a great day!\n' +
            '\n' +
            'Best,\n' +
            'Sarah,\n' +
            'ABC Digital Support'
    }
}

export default transcriptSamples
